export default "__VITE_ASSET__AbyaLx29__"